import React from "react";
import Page from "./page";

export default function Index(props) {

	return (
		<Page />
	);
}